import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
};
export const Hr = ({ className }: Props) => (
  <hr
    className={classnames(
      'm-0 block h-1 border-0 border-t-1 border-solid border-lightGrey p-0',
      className,
    )}
  />
);
